import { render, staticRenderFns } from "./soon.vue?vue&type=template&id=1e4daa0a&scoped=true"
import script from "./soon.vue?vue&type=script&lang=js"
export * from "./soon.vue?vue&type=script&lang=js"
import style0 from "./soon.vue?vue&type=style&index=0&id=1e4daa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4daa0a",
  null
  
)

export default component.exports